<template>
  <div>
    <h4 class="text-center">{{title}}</h4>
    <slot name="pre-hr mb-1"></slot>
    <hr v-if="!hide_hr" class="my-1">
    <div class="flex justify-center">
      <p class="md:w-[75%] text-center mb-1">
        <slot></slot>
      </p>
    </div>
    <slot name="outer-slot"></slot>

  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    hide_hr: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scope>
/* {} */
</style>